export default __webpack_public_path__ + "static/media/Twitter.0da88b71.svg";